import React, { useEffect, useState } from "react";
import "./GoldLoanScheme.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Edit, Eye, Trash } from "lucide-react";

const BASE_API_URL = "https://payyug.in";
const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
const tenureTypes = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "bi-weekly",
  "Days",
];
const recoveryFrequencys = [
  "Monthly",
  "Quarterly",
  "Half-Yearly",
  "Yearly",
  "Weekly",
  "bi-weekly",
  "Daily",
];

const initialFormState = {
  serviceType: "",
  schemeName: "",
  schemeCode: "",
  minLoanAmount: "",
  maxLoanAmount: "",
  roiPercent: "",
  roiType: "",
  interestCalculationMethod: "",
  penalInterestPercent: "",
  gracePeriodDays: "",
  tenureType: "",
  minTenure: "",
  maxTenure: "",
  recoveryFrequency: "",
  processingFeeType: "",
  processingFeeValue: "",
  valuationCharges: "",
  documentationCharges: "",
  insuranceCharges: "",
  gstApplicable: "",
  foreclosureChargesPercent: "",
  goldRateType: "",
  rateLockPeriodDays: "",
  revaluationAllowed: "",
  topUpAllowed: "",
  minNetWeight: "",
  maxNetWeight: "",
  allowedPurity: "",
  hallmarkMandatory: "",
  eligibleGoldRatePercent: "",
  ltvPercent: "",
  perGramCapLimit: "",
  isActive: false,
};

const GoldLoanScheme = () => {
  const [formData, setFormData] = useState(initialFormState);
  const [schemes, setSchemes] = useState([]);

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRow,setSelectedRow]=useState(null)

  const [editingId, setEditingId] = useState(null);

  /* ================= FETCH ================= */
  const fetchSchemes = async () => {
    try {
      const res = await axios.get(
        `${BASE_API_URL}//api//gold-loan/scheme/list`,
        {
          params: {
            superAdminId: localStorage.getItem("adminuserId"),
            page: currentPage,
            limit: rowsPerPage,
          },
        },
      );

      setSchemes(res.data.data);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchSchemes();
  }, [currentPage, rowsPerPage]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "radio"
            ? value === "yes"
            : value,
    }));
  };

  /* ================= CREATE / UPDATE ================= */
  const handleSubmit = async (e) => {
    e.preventDefault();

    // if(formData.serviceType || formData.schemeName){
    //   toast.warning("Please fill all required fields")
    // }

    const superAdminId = localStorage.getItem("adminuserId");
    const payload = {
      ...formData,
      superAdminId,
      branchId: 2,
    };

    try {
      if (editingId) {
        console.log(editingId)
       const res= await axios.put(
          `${BASE_API_URL}/api/gold-loan/scheme/${editingId}`,
          payload,
        );
        toast.success(res.data.message||"Scheme Updated Successfully");
      } else {
       const res= await axios.post(
          `${BASE_API_URL}/api/gold-loan/scheme/create`,
          payload,
        );
        toast.success(res.data.message||"Scheme Created Successfully");
      }

      resetForm()
      fetchSchemes();
    } catch (error) {
      toast.error(error.response.data.message);
      console.error("Submit error:", error);
    }
  };

  const resetForm=()=>{
    setFormData(initialFormState)
    setEditingId(null);
  }

  /* ================= EDIT ================= */
  const handleEdit = (scheme) => {
    setFormData(scheme);
    setEditingId(scheme.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete?")) return;

    try {
      await axios.delete(`${BASE_API_URL}/api/gold-loan/scheme/${id}`);
      toast.success("Scheme Deleted Successfully");
      fetchSchemes();
    } catch (error) {
      toast.error(error.response.data.message)
      console.error("Delete error:", error);
    }
  };

  /* ================= PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <div className="gold-loan-scheme-container">
      <h1 className="gold-loan-scheme-heading">Gold Loan Scheme</h1>

      {/* ================= TOP ================= */}
      <section className="gold-loan-scheme-top">
        <div className="gold-loan-scheme-top-header">
          <h2>
            {editingId
              ? "Update Gold Loan Scheme"
              : "Gold Loan Scheme Create"}
          </h2>
        </div>

        <form className="gold-loan-scheme-form" onSubmit={handleSubmit}>
          <div className="gold-loan-scheme-form-section">
            <div className="gold-loan-scheme-form-input-fields">
              <label>Service Type</label>
              <select
                name="serviceType"
                value={formData.serviceType}
                onChange={handleChange}
              >
                <option value="">Select Service</option>
                <option value="Gold Loan">Gold Loan</option>
                <option value="Silver Loan">Silver Loan</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Scheme Name</label>
              <input
                type="text"
                name="schemeName"
                value={formData.schemeName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="gold-loan-scheme-form-input-fields">
              <label>Scheme Code</label>
              <input
                type="text"
                name="schemeCode"
                value={formData.schemeCode}
                onChange={handleChange}
              />
            </div>
            <div className="gold-loan-scheme-form-input-fields">
              <label>Minimum Loan Amount</label>
              <input
                type="number"
                name="minLoanAmount"
                value={formData.minLoanAmount}
                onChange={handleChange}
              />
            </div>
            <div className="gold-loan-scheme-form-input-fields">
              <label>Maximum Loan Amount</label>
              <input
                type="number"
                name="maxLoanAmount"
                value={formData.maxLoanAmount}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>ROI (%)</label>
              <input
                type="number"
                name="roiPercent"
                value={formData.roiPercent}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>ROI Type</label>
              <select
                name="roiType"
                value={formData.roiType}
                onChange={handleChange}
              >
                <option value="">Select ROI Type</option>
                <option value="Flat">Flat</option>
                <option value="Reducing">Reducing</option>
                <option value="Daily">Daily</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Interest Calculation Method</label>
              <select
                name="interestCalculationMethod"
                value={formData.interestCalculationMethod}
                onChange={handleChange}
              >
                <option value="">--Select--</option>
                <option value="Monthly">Monthly</option>
                <option value="Quaterly">Quaterly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Penalty Interest (%)</label>
              <input
                type="number"
                name="penalInterestPercent"
                value={formData.penalInterestPercent}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Grace Period Days</label>
              <input
                type="number"
                name="gracePeriodDays"
                value={formData.gracePeriodDays}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Tenure Type</label>
              <select
                name="tenureType"
                value={formData.tenureType}
                onChange={handleChange}
              >
                <option value="">Select Tenure Type</option>
                {tenureTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>
                {`Min Tenure ${formData.tenureType ? "(" + formData.tenureType + ")" : ""}`}{" "}
              </label>
              <input
                type="number"
                name="minTenure"
                value={formData.minTenure}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>{`Max Tenure ${formData.tenureType ? "(" + formData.tenureType + ")" : ""}`}</label>
              <input
                type="number"
                name="maxTenure"
                value={formData.maxTenure}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Recovery Frequency</label>
              <select
                name="recoveryFrequency"
                value={formData.recoveryFrequency}
                onChange={handleChange}
              >
                <option value="">Select Recovery Frequency</option>
                {recoveryFrequencys.map((freq) => (
                  <option key={freq} value={freq}>
                    {freq}
                  </option>
                ))}
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Processing Fee Type</label>
              <select
                name="processingFeeType"
                value={formData.processingFeeType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="Fixed">Fixed</option>
                <option value="Percent">Percent</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Processing Fee Value</label>
              <input
                type="number"
                name="processingFeeValue"
                value={formData.processingFeeValue}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Valuation Charges</label>
              <input
                type="number"
                name="valuationCharges"
                value={formData.valuationCharges}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Documentation Charges</label>
              <input
                type="number"
                name="documentationCharges"
                value={formData.documentationCharges}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Insurance Charges</label>
              <input
                type="number"
                name="insuranceCharges"
                value={formData.insuranceCharges}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>GST Applicable</label>
              <div className="radio-inputs">
                <label>
                  <input
                    type="radio"
                    name="gstApplicable"
                    value="yes"
                    checked={formData.gstApplicable === true}
                    onChange={handleChange}
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="gstApplicable"
                    value="no"
                    checked={formData.gstApplicable === false}
                    onChange={handleChange}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Closer Charges (%)</label>
              <input
                type="number"
                name="foreclosureChargesPercent"
                value={formData.foreclosureChargesPercent}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Gold Rate Type</label>
              <select
                name="goldRateType"
                value={formData.goldRateType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="Market">Market</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Rate Lock Period (Days)</label>
              <input
                type="number"
                name="rateLockPeriodDays"
                value={formData.rateLockPeriodDays}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Revolution</label>
              <div className="radio-inputs">
                <label>
                  <input
                    type="radio"
                    name="revaluationAllowed"
                    value="yes"
                    checked={formData.revaluationAllowed === true}
                    onChange={handleChange}
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="revaluationAllowed"
                    value="no"
                    checked={formData.revaluationAllowed === false}
                    onChange={handleChange}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Top-Up</label>
              <div className="radio-inputs">
                <label>
                  <input
                    type="radio"
                    name="topUpAllowed"
                    value="yes"
                    checked={formData.topUpAllowed === true}
                    onChange={handleChange}
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="topUpAllowed"
                    value="no"
                    checked={formData.topUpAllowed === false}
                    onChange={handleChange}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Minimum Net Weight (grams)</label>
              <input
                type="number"
                name="minNetWeight"
                value={formData.minNetWeight}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Maximum Net Weight (grams)</label>
              <input
                type="number"
                name="maxNetWeight"
                value={formData.maxNetWeight}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Purity</label>
              <select
                name="allowedPurity"
                value={formData.allowedPurity}
                onChange={handleChange}
              >
                <option value="">Select Method</option>
                <option value="18K">18K</option>
                <option value="20K">20K</option>
                <option value="22K">22K</option>
                <option value="24K">24K</option>
              </select>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>HallMark</label>
              <div className="radio-inputs">
                <label>
                  <input
                    type="radio"
                    name="hallmarkMandatory"
                    value="yes"
                    checked={formData.hallmarkMandatory === true}
                    onChange={handleChange}
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="hallmarkMandatory"
                    value="no"
                    checked={formData.hallmarkMandatory === false}
                    onChange={handleChange}
                  />
                  No
                </label>
              </div>
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Eligible Gold Rate (%)</label>
              <input
                type="text"
                name="eligibleGoldRatePercent"
                value={formData.eligibleGoldRatePercent}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>LTV % (Loan To Value Percentage)</label>
              <input
                type="text"
                name="ltvPercent"
                value={formData.ltvPercent}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields">
              <label>Per Gram Capital Limit</label>
              <input
                type="text"
                name="perGramCapLimit"
                value={formData.perGramCapLimit}
                onChange={handleChange}
              />
            </div>

            <div className="gold-loan-scheme-form-input-fields-active-check">
              <label className="active-check">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive || false}
                  onChange={handleChange}
                />
                Active
              </label>
            </div>
          </div>

          <div className="gold-loan-scheme-form-submit-btn">
            <button type="submit" className="gl-submit-btn">
              {editingId ? "Update Scheme" : "Add Scheme"}
            </button>
            {editingId && <button className="gl-cancel-btn" onClick={resetForm}>Cancel</button>}
          </div>
        </form>
      </section>

      {/* ================= REPORT ================= */}
      <div className="gold-loan-scheme-report-container">
        <h1>Gold Loan Scheme Report</h1>

        <div className="gold-loan-scheme-report-filter-div">
          {/* <input
            type="text"
            placeholder="Search by Group / Type / Status..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          /> */}
          <div className="gold-loan-scheme-filter">
            <label>Show </label>
            <select value={rowsPerPage} onChange={handleItemsPerPageChange}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="gold-loan-scheme-report-table-container">
          <table className="gold-loan-scheme-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Service Type</th>
                <th>Scheme Name</th>
                <th>Scheme Code</th>
                <th>Min Loan Amount</th>
                <th>Max Loan Amount</th>
                <th>Roi(%)</th>
                <th>Roi Type</th>
                <th>Interest Calculation Method</th>
                <th>Penalty Interest (%)</th>
                <th>Grace Period(Days)</th>
                <th>Min Tenure</th>
                <th>Max Tenure</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {schemes.length > 0 ? (
                schemes.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.serviceType||"N/A"}</td>
                    <td>{item.schemeName||"N/A"}</td>
                    <td>{item.schemeCode||"N/A"}</td>
                    <td>{item.minLoanAmount||"N/A"}</td>
                    <td>{item.maxLoanAmount||"N/A"}</td>
                    <td>{item.roiPercent||"N/A"}</td>
                    <td>{item.roiType||"N/A"}</td>
                    <td>{item.interestCalculationMethod||"N/A"}</td>
                    <td>{item.penalInterestPercent||"N/A"}</td>
                    <td>{item.gracePeriodDays||"N/A"}</td>
                    <td>{item.minTenure||"N/A"}</td>
                    <td>{item.maxTenure||"N/A"}</td>
                    <td>
                      <div className="gold-loan-report-action-btns">
                        <button className="gold-view-btn" onClick={() => setSelectedRow(item)}><Eye/></button>
                        <button className="gold-edit-btn" onClick={() => handleEdit(item)}><Edit/></button>
                        <button className="gold-delete-btn" onClick={() => handleDelete(item.id)}>
                          <Trash/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" style={{ textAlign: "center" }}>
                    No results found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= PAGINATION ================= */}
      {totalPages > 1 && (
        <div className="gold-loan-scheme-pagination-div">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next ➡
          </button>
        </div>
      )}



      {selectedRow && (
        <div className="view-gold-scheme-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="view-gold-scheme-modal"
            onClick={(e) => e.stopPropagation()}   // prevent close when clicking inside
          >
            <div className="view-gold-scheme-modal-header">
              <h3>Account Details</h3>
              <button
                className="view-gold-scheme-modal-close"
                onClick={() => setSelectedRow(null)}
              >
                ✖
              </button>
            </div>
            <table className="view-gold-loan-scheme-data">
              <tr>
                <th>Service Type</th>
                <td>{selectedRow.serviceType}</td>
                <th>Scheme Name</th>
                <td>{selectedRow.schemeName}</td>
              </tr>
              <tr>
                <th>Scheme Code</th>
                <td>{selectedRow.schemeCode}</td>
                <th>Min Loan Amount</th>
                <td>{selectedRow.minLoanAmount}</td>
              </tr>
              <tr>
                <th>Max Loan Amount</th>
                <td>{selectedRow.maxLoanAmount}</td>
                <th>Roi (%)</th>
                <td>{selectedRow.roiPercent}</td>
              </tr>
              <tr>
                <th>Roi Type</th>
                <td>{selectedRow.roiType}</td>
                <th>Interest Calculation Method</th>
                <td>{selectedRow.interestCalculationMethod}</td>
              </tr>
              <tr>
                <th>Penalty Interest (%)</th>
                <td>{selectedRow.penalInterestPercent}</td>
                <th>Grace Period Days</th>
                <td>{selectedRow.gracePeriodDays}</td>
              </tr>
              <tr>
                <th>Min Tenure</th>
                <td>{selectedRow.minTenure}</td>
                <th>Max Tenure</th>
                <td>{selectedRow.maxTenure}</td>
              </tr>
              <tr>
                <th>Tenure Type</th>
                <td>{selectedRow.tenureType}</td>
                <th>Recovery Frequency</th>
                <td>{selectedRow.recoveryFrequency}</td>
              </tr>
              <tr>
                <th>Processing Fee Type</th>
                <td>{selectedRow.processingFeeType}</td>
                <th>Processing Fee Value</th>
                <td>{selectedRow.processingFeeValue}</td>
              </tr>
              <tr>
                <th>Valuation Charges</th>
                <td>{selectedRow.valuationCharges}</td>
                <th>Documetation Charges</th>
                <td>{selectedRow.documentationCharges}</td>
              </tr>
              <tr>
                <th>Insurance Charges</th>
                <td>{selectedRow.insuranceCharges}</td>
                <th>Gst Applicable</th>
                <td>{selectedRow.gstApplicable===true?"Yes":"No"}</td>
              </tr>
              <tr>
                <th>For Closer Charges (%)</th>
                <td>{selectedRow.foreclosureChargesPercent}</td>
                <th>Gold Rate Type</th>
                <td>{selectedRow.goldRateType}</td>
              </tr>
              <tr>
                <th>Rate Lock Period Days</th>
                <td>{selectedRow.rateLockPeriodDays}</td>
                <th>Revaluation Allowed</th>
                <td>{selectedRow.revaluationAllowed===true?"Yes":"No"}</td>
              </tr>
              <tr>
                <th>Top Up Allowed</th>
                <td>{selectedRow.topUpAllowed===true?"Yes":"No"}</td>
                <th>Min Net Weight</th>
                <td>{selectedRow.minNetWeight}</td>
              </tr>
              <tr>
                <th>Max Net Weight</th>
                <td>{selectedRow.maxNetWeight}</td>
                <th>Purity</th>
                <td>{selectedRow.allowedPurity}</td>
              </tr>
              <tr>
                <th>Hallmark</th>
                <td>{selectedRow.hallmarkMandatory===true?"Yes":"No"}</td>
                <th>Eligible Gold Rate (%)</th>
                <td>{selectedRow.eligibleGoldRatePercent}</td>
              </tr>
              <tr>
                <th>Ltv (%)</th>
                <td>{selectedRow.ltvPercent}</td>
                <th>Per Gram Capital Limit</th>
                <td>{selectedRow.perGramCapLimit}</td>
              </tr>
              <tr>
                <th colSpan={"2"}>Active</th>
                <td colSpan={"2"}>{selectedRow.isActive===true?"Yes":"No"}</td>
                
              </tr>
            </table>
            

            <button className="view-gold-scheme-modal-close-btn"
              onClick={() => setSelectedRow(null)}
            >Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoldLoanScheme;
